import {useEffect, useState} from "react";

export function useScript(src: string) {
    const [scriptLoaded, setScriptLoaded] = useState(false);

    useEffect(() => {
        const scriptTag = document.createElement("script");
        scriptTag.src = src;
        scriptTag.addEventListener("load", () => setScriptLoaded(true));
        document.body.appendChild(scriptTag);
    }, [src]);

    return scriptLoaded;
}
